import React from 'react';
import { Card, Table, Typography, Tag, Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { JournalEntry } from '../../../services/accountingService';
import { formatCurrency } from './journalEntriesHelpers';

const { Text } = Typography;

export interface JournalEntriesTableProps {
  entries: JournalEntry[];
  loading: boolean;
  onOpenDetail: (record: JournalEntry) => void;
}

export const JournalEntriesTable: React.FC<JournalEntriesTableProps> = ({
  entries,
  loading,
  onOpenDetail,
}) => {
  const columns = [
    {
      title: 'Comprobante',
      dataIndex: 'entry_number',
      key: 'entry_number',
      width: 160,
      render: (num: string, r: any) => (
        <Text strong style={{ color: '#1677ff' }}>
          {num || r.number || (r.id ? `CC-${r.id}` : '—')}
        </Text>
      ),
    },
    {
      title: 'Fecha',
      dataIndex: 'entry_date',
      key: 'entry_date',
      width: 120,
      render: (d: string, r: any) => {
        const val = d || r.date;
        return val ? dayjs(val).format('DD/MM/YYYY') : '—';
      },
    },
    {
      title: 'Concepto / Descripción',
      dataIndex: 'concept',
      key: 'concept',
      ellipsis: true,
      render: (c: string, r: any) => c || r.description || '—',
    },
    {
      title: 'Total Débito',
      dataIndex: 'total_debit',
      key: 'total_debit',
      width: 150,
      align: 'right' as const,
      render: (val: number) => (
        <Text strong style={{ color: '#1677ff', whiteSpace: 'nowrap' }}>
          {formatCurrency(val)}
        </Text>
      ),
    },
    {
      title: 'Total Crédito',
      dataIndex: 'total_credit',
      key: 'total_credit',
      width: 150,
      align: 'right' as const,
      render: (val: number) => (
        <Text strong style={{ color: '#722ed1', whiteSpace: 'nowrap' }}>
          {formatCurrency(val)}
        </Text>
      ),
    },
    {
      title: 'Estado',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      align: 'center' as const,
      render: (status: string) => (
        <Tag color={status === 'POSTED' ? 'green' : status === 'DRAFT' ? 'gold' : 'red'}>
          {status === 'POSTED' ? 'ASENTADO' : status === 'DRAFT' ? 'BORRADOR' : 'ANULADO'}
        </Tag>
      ),
    },
    {
      title: 'Acciones',
      key: 'actions',
      width: 90,
      align: 'center' as const,
      render: (_: any, record: JournalEntry) => (
        <Button
          type="text"
          icon={<EyeOutlined />}
          onClick={() => onOpenDetail(record)}
          size="small"
        >
          Ver
        </Button>
      ),
    },
  ];

  return (
    <Card bordered={false} style={{ borderRadius: 8 }}>
      <Table
        dataSource={entries}
        columns={columns}
        rowKey="id"
        loading={loading}
        pagination={{ pageSize: 15, showSizeChanger: true }}
        size="middle"
      />
    </Card>
  );
};
